import { CommonModule, NgOptimizedImage } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AngularDatasModule } from '@univacity/angular/datas';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzUploadModule } from 'ng-zorro-antd/upload';
// import { NgxSummernoteModule } from 'ngx-summernote';
import {
  CarouselComponent,
  InfoCarouselComponent,
  NavComponent,
  NotesComponent,
} from './components';
import { ActionButtonsComponent } from './components/action-buttons/action-buttons.component';
import { ActionListComponent } from './components/action-lists/action-list.component';
import { AlertComponent } from './components/alert/alert.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ButtonComponent } from './components/button/button.component';
import { CostWidgetComponent } from './components/cost-widget/cost-widget.component';
import { CountryCardComponent } from './components/country-card/country-card.component';
import { CreateNoteComponent } from './components/create-note/create-note.component';
import { EmptyComponent } from './components/empty/empty.component';
import { FileInputComponent } from './components/file-input/file-input.component';
import { FilePreviewComponent } from './components/file-preview/file-preview.component';
import { FormArrayTabsComponent } from './components/form-array-tabs/form-array-tabs.component';
import { IconComponent } from './components/icon/icon.component';
import { InfoWidgetComponent } from './components/info-widget/info-widget.component';
import { InputRangeComponent } from './components/input-range/input-range.component';
import { InputComponent } from './components/input/input.component';
import { NoteComponent } from './components/notes/note/note.component';
import { PagniationComponent } from './components/pagniation/pagniation.component';
import { PassangersInputComponent } from './components/passangers-input/passangers-input.component';
import { PhoneInputComponent } from './components/phone-input/phone-input.component';
import { SliderComponent } from './components/slider/slider.component';
import { StepTitleComponent } from './components/steps/step-title/step-title.component';
import { StepComponent } from './components/steps/step/step.component';
import { StepsComponent } from './components/steps/steps/steps.component';
import { TableComponent } from './components/table/table.component';
import { TagComponent } from './components/tag/tag.component';
import { ViewSwitchComponent } from './components/view-switch/view-switch.component';
import { Configuration } from './configuration';
import { pipes } from './pipes';
import { QuillModule } from 'ngx-quill';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgOptimizedImage,
    RouterModule,
    NzSpinModule,
    NzIconModule,
    NzSliderModule,
    NzFormModule,
    NzInputModule,
    NzInputNumberModule,
    NzSelectModule,
    NzCheckboxModule,
    NzRadioModule,
    NzAutocompleteModule,
    NzPaginationModule,
    NzAlertModule,
    NzDropDownModule,
    NzMenuModule,
    NzBreadCrumbModule,
    NzCollapseModule,
    NzDrawerModule,
    NzModalModule,
    NzUploadModule,
    NzDatePickerModule,
    NzTabsModule,
    NzPopconfirmModule,
    AngularDatasModule,
    NzBadgeModule,
    FontAwesomeModule,
    QuillModule,
  ],
  declarations: [
    ...pipes,
    ButtonComponent,
    InputComponent,
    InputRangeComponent,
    SliderComponent,
    PagniationComponent,
    AlertComponent,
    IconComponent,
    CarouselComponent,
    CountryCardComponent,
    InfoWidgetComponent,
    TagComponent,
    FilePreviewComponent,
    BreadcrumbComponent,
    CostWidgetComponent,
    InfoCarouselComponent,
    EmptyComponent,
    ActionListComponent,
    NoteComponent,
    NotesComponent,
    NavComponent,
    ViewSwitchComponent,
    StepsComponent,
    StepComponent,
    StepTitleComponent,
    FileInputComponent,
    ActionButtonsComponent,
    FormArrayTabsComponent,
    TableComponent,
    PassangersInputComponent,
    PhoneInputComponent,
    CreateNoteComponent,
  ],
  exports: [
    ...pipes,

    ButtonComponent,
    SliderComponent,
    InputComponent,
    AlertComponent,
    PagniationComponent,
    IconComponent,
    CarouselComponent,
    CountryCardComponent,
    InfoWidgetComponent,
    TagComponent,
    FilePreviewComponent,
    BreadcrumbComponent,
    CostWidgetComponent,
    InfoCarouselComponent,
    EmptyComponent,
    ActionListComponent,
    NotesComponent,
    NavComponent,
    ViewSwitchComponent,
    StepsComponent,
    StepComponent,
    ActionButtonsComponent,
    FormArrayTabsComponent,
    TableComponent,
    PassangersInputComponent,
    PhoneInputComponent,
  ],
})
export class AngularUiModule {
  constructor(
    @Optional() @SkipSelf() parentModule: AngularUiModule,
    @Optional() http: HttpClient
  ) {
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }
  }

  public static forRoot(
    configurationFactory: () => Configuration
  ): ModuleWithProviders<AngularUiModule> {
    return {
      ngModule: AngularUiModule,
      providers: [{ provide: Configuration, useFactory: configurationFactory }],
    };
  }
}
